import router from "src/routes/routes";
import CommonAPIService from "src/serviceHandlers/commonHandler";

const api = new CommonAPIService(router);

// routes/authorizationEmails.js mounts at /api/authorizationEmails and its
// paths repeat the resource name, hence the doubled segment.
export const authorizationEmailsService = {
  // All non-archived VR service codes with each code's saved ai_email_prompt,
  // plus the built-in generic default prompt used when a code has none.
  getSupportedCodes: () =>
    api.getCall("/api/authorizationEmails/authorization-emails/supported-codes"),
};
